import React from "react";
import "../styles/PrivacyPolicy.css";

import { useTranslation } from 'react-i18next';

const CONSENT_KEY = 'zeldle-cookie-consent';

export default function PrivacyPolicy() {
	const { t } = useTranslation();

	const handleReopenConsent = () => {
		localStorage.removeItem(CONSENT_KEY);
		window.location.reload();
	};

	return (

		<div className="privacypolicy">
			<h1>{t('privacy.title')}</h1>
			<p><strong>{t('privacy.lastUpdate')} :</strong> {t('privacy.date')}</p>

			<p>{t('privacy.welcome')} <strong>zeldle.xyz</strong>.</p>

			<p>
				{t('privacy.intro')}
			</p>

			<h2>{t('privacy.section1Title')}</h2>
			<p>
				{t('privacy.section1Text')}
			</p>

			<h2>{t('privacy.section2Title')}</h2>
			<p>
				{t('privacy.section2Text')}
			</p>
			<p>
				{t('privacy.section2Link')}<br />
				👉 <a href="https://monetag.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
				https://monetag.com/privacy-policy/
				</a>
			</p>

			<h2>{t('privacy.section3Title')}</h2>
			<p>
				{t('privacy.section3Text1')}
			</p>
			<p>
				{t('privacy.section3Text2')}
			</p>
			<button className="privacy-manage-consent" onClick={handleReopenConsent}>
				{t('privacy.manageCookies')}
			</button>

			<h2>{t('privacy.section4Title')}</h2>
			<p>
				{t('privacy.section4Text')}
			</p>

			<h2>{t('privacy.section5Title')}</h2>
			<p>
				{t('privacy.section5Text')}<br />
				📧 <a href="mailto:contact@zeldle.xyz">contact@zeldle.xyz</a>
			</p>
		</div>
	);
}